<template>
    <div v-if="showModal">
        <div class="backdrop" @click="close"></div>
        <div class="card card-outline card-primary card-box mx-auto">

            <div class="card-header">
                <h3 class="card-title">Repousser la date limite de la demande de dispense</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" @click="close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="modal-card-body">
                <p v-if="exemption" class="mb-3 font-weight-bold">
                    {{ exemption.civility }} {{ exemption.firstName }} {{ exemption.lastName }}
                </p>

                <div class="form-group">
                    <label class="required-field-asterisks" for="extend-deadline-date">
                        Nouvelle date limite
                    </label>
                    <Vue2DatePicker
                        id="extend-deadline-date"
                        v-model="newDeadlineDate"
                        format="DD/MM/YYYY"
                        valueType="YYYY-MM-DD"
                        :disabled-date="isDateDisabled"
                        :clearable="false"
                        placeholder="Choisir une date"
                        class="w-100"
                    />
                </div>

                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="extend-send-reminder"
                            v-model="sendReminderEmail"
                        />
                        <label class="custom-control-label" for="extend-send-reminder">
                            Envoyer un mail de relance à l'{{ agentOrEmployee }}
                        </label>
                    </div>
                </div>

                <div v-if="errorMessage" class="alert alert-danger mt-2 mb-0">
                    {{ errorMessage }}
                </div>
            </div>

            <div class="modal-card-actions text-right">
                <button class="btn btn-secondary mr-2" @click="close" :disabled="isLoading">
                    Annuler
                </button>
                <button
                    class="btn btn-primary button-blue"
                    :disabled="!newDeadlineDate || isLoading"
                    @click.prevent="confirm"
                >
                    <span>OK</span>
                    <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm ml-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue2DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/fr';
    import { extendExemptionDeadline } from '@/service/api/exemptions.api';

    export default {
        props: {
            showModal: Boolean,
            exemption: Object,
            enterpriseSector: String,
        },
        data() {
            return {
                newDeadlineDate: null,
                sendReminderEmail: false,
                errorMessage: null,
                isLoading: false,
            };
        },
        computed: {
            agentOrEmployee() {
                return this.enterpriseSector === 'public' ? 'agent' : 'employé';
            },
        },
        watch: {
            showModal(isOpen) {
                if (isOpen) {
                    this.newDeadlineDate = this.computeDefaultDate();
                    this.sendReminderEmail = false;
                    this.errorMessage = null;
                    this.isLoading = false;
                }
            },
        },
        methods: {
            computeDefaultDate() {
                const date = new Date();
                date.setDate(date.getDate() + 10);
                const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                const pad = (n) => String(n).padStart(2, '0');
                return `${lastDayOfMonth.getFullYear()}-${pad(lastDayOfMonth.getMonth() + 1)}-${pad(lastDayOfMonth.getDate())}`;
            },
            isDateDisabled(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const maxDate = new Date();
                maxDate.setMonth(maxDate.getMonth() + 2);
                return date <= today || date > maxDate;
            },
            async confirm() {
                if (!this.newDeadlineDate) {
                    this.errorMessage = 'Veuillez choisir une date.';
                    return;
                }
                this.isLoading = true;
                this.errorMessage = null;
                try {
                    await extendExemptionDeadline(
                        this.exemption.id,
                        this.newDeadlineDate,
                        this.sendReminderEmail,
                    );
                    this.isLoading = false;
                    this.close();
                    this.$emit('extendSuccess', { sendReminderEmail: this.sendReminderEmail, agentOrEmployee: this.agentOrEmployee });
                } catch ({ response }) {
                    const knownMessage = response?.data?.violations?.[0]?.message
                        || response?.data?.title;
                    this.errorMessage = knownMessage || 'Une erreur est survenue, veuillez réessayer.';
                } finally {
                    this.isLoading = false;
                }
            },
            close() {
                if (!this.isLoading) {
                    this.$emit('update:showModal', false);
                }
            },
        },
        components: { Vue2DatePicker },
    };
</script>

<style scoped>

  .custom-control-label {
    margin-top: 20px;
  }

</style>
